<template>
    <div class="h-128" style="width: 100%">
        <l-map
            v-if="showMap"
            :zoom="zoom"
            :center="center"
            :options="mapOptions"
            style="height: 400px"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
            ref="map"
        >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker :lat-lng="withPopup">
                <!--<l-popup>
                    <div @click="innerClick">
                        I am a popup
                        <p v-show="showParagraph">
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
                            sed pretium nisl, ut sagittis sapien. Sed vel sollicitudin nisi.
                            Donec finibus semper metus id malesuada.
                        </p>
                    </div>
                </l-popup>-->
            </l-marker>
        </l-map>
    </div>
</template>

<script>
    import { latLng } from "leaflet";
    import { LMap, LTileLayer, LMarker, /*LPopup*/ } from "vue2-leaflet";
    import { Icon } from 'leaflet';

    export default {
        name: "Example",
        components: {
            LMap,
            LTileLayer,
            LMarker,
            /*LPopup*/
        },
        data() {
            return {
                zoom: 16,
                center: latLng(this.coords[1], this.coords[0]),
                url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                attribution:
                    '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
                withPopup: latLng(this.coords[1], this.coords[0]),
                currentZoom: 11.5,
                currentCenter: latLng(this.coords[1], this.coords[0]),
                showParagraph: false,
                mapOptions: {
                    zoomSnap: 0.5,
                    scrollWheelZoom: false
                },
                showMap: true
            };
        },
        props: {
          coords: {}
        },
        methods: {
            zoomUpdate(zoom) {
                this.currentZoom = zoom;
            },
            centerUpdate(center) {
                this.currentCenter = center;
            },
            showLongText() {
                this.showParagraph = !this.showParagraph;
            },
            innerClick() {
                alert("Click!");
            },
          refresh() {
              this.$refs.map.invalidateSize()
          }
        },
        beforeMount() {
            delete Icon.Default.prototype._getIconUrl;
            Icon.Default.mergeOptions({
                iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
                iconUrl: require('leaflet/dist/images/marker-icon.png'),
                shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
            });
        }
    };
</script>
